import { SVG } from './esveegee.js'

export const shaper = (s: SVG) => {
    const points = [16, 300, 50, 100, 120, 250, 200, 250, 300, 300 - 16]

    for (let i = 0; i < points.length; i += 4) {
        const p1 = s.circle(points[i], points[i + 1], 3).draggable().fill('blue')
        const p2 = s.circle(points[i + 2], points[i + 3], 3).draggable().fill('blue')
//        s.line(p1, p2)
    }
}
